import React from "react";
import "../App.css";
import { useTranslation } from "react-i18next";

export default function AidanRoutineCottbus() {
  const { t } = useTranslation();
  return (
    <div className="ow-video-wrap">
      <div className="ow-video-frame ow-video-frame-ratio">
        <iframe
          src="https://www.youtube.com/embed/79ae2pn9sf8"
          title="Aidan Li pommel horse routine at the 2026 Cottbus Artistic Gymnastics World Cup"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share"
          allowFullScreen
          loading="lazy"
        />
      </div>
      <p className="ow-video-caption">{t("cottbus-routine")}</p>
    </div>
  );
}
